import { useSelector } from "react-redux";
import { AppState } from "../../services/redux/index";

export function useSwapState(): AppState["swap"] {
  return useSelector<AppState, AppState["swap"]>((state) => state.swap);
}
